
type DataLayerEvent = {
  event: string;
  [key: string]: any;
};

declare global {
  interface Window {
    dataLayer: DataLayerEvent[];
  }
}

export const initializeDataLayer = (): void => {
  window.dataLayer = window.dataLayer || [];
};
